import React, { createContext, useEffect, useMemo } from 'react';
import { theme as defaultTheme } from '@tribeplatform/design-system/themes/default';
import { useDocument } from '../hooks/useDocument.js';
import { applyTheme } from './utils.js';
export const ThemeContext = createContext({
    theme: defaultTheme,
});
export const ThemeProvider = ({ children, theme = defaultTheme, colorScheme = 'light', }) => {
    const { document } = useDocument();
    const contextValue = useMemo(() => ({
        theme,
    }), [theme]);
    useEffect(() => {
        const root = document.documentElement;
        applyTheme(theme, colorScheme, root);
    }, [document, theme, colorScheme]);
    return (React.createElement(ThemeContext.Provider, { value: contextValue }, children));
};
//# sourceMappingURL=ThemeProvider.js.map